import {ACCESS_LOG, FETCH_LIVE_SCHEDULE, FETCH_ONE_TO_MANY, FETCH_ONE_TO_ONE, LIVE_STATUS_CHANGE} from "../index";
import http from "../../apis/service";
import {
    accessLog,
    courses,
    instructor,
    instructorPresentEndPoint,
    live,
    nextLive,
    one_to_many,
    one_to_one
} from "../../apis/endPoint";

export const accessLogSend = (instructor_id, request_url) => async dispatch => {
    const response = await http.postWithBody(`${instructor}/${accessLog}`, {
        instructor_id,
        request_url
    });
    dispatch({
        type: ACCESS_LOG,
        payload: response
    });
};

export const instructorPresent = (instructor_id, tuition_classes_id, tuition_config_id, class_num) => async dispatch => {
    const response = await http.postWithBody(`${instructorPresentEndPoint}`, {
        instructor_id,
        tuition_classes_id,
        tuition_config_id,
        class_num
    });
    dispatch({
        type: ACCESS_LOG,
        payload: response
    });
};


export const getLiveSchedule = (instructor_id) => async dispatch => {
    const response = await http.get(`${instructor}/${nextLive}/${instructor_id}`);
    dispatch({
        type: FETCH_LIVE_SCHEDULE,
        payload: response
    });
};

export const getOneToOneSchedule = (instructor_id) => async dispatch => {
    const response = await http.get(`${instructor}/${courses}/${one_to_one}/${instructor_id}`);
    dispatch({
        type: FETCH_ONE_TO_ONE,
        payload: response
    });
};

export const getOneToManySchedule = (instructor_id) => async dispatch => {
    const response = await http.get(`${instructor}/${courses}/${one_to_many}/${instructor_id}`);
    dispatch({
        type: FETCH_ONE_TO_MANY,
        payload: response
    });
};

export const changeStreamUrl = (instructor_id, stream_url) => async dispatch => {
    const response = await http.putWithFormData(`${instructor}/${live}`, {
        instructor_id,
        stream_url
    });
    dispatch({
        type: LIVE_STATUS_CHANGE,
        payload: response
    });
};